module.exports = __webpack_public_path__ + "img/ertiga-boostergreen-glx-rojo-escarlata.0d67afcf.png";